import {Record, List} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import Name from 'web-app/react/entities/common/name';

class Assignment extends Record<{
    roleId: string;
    targetId: string;
}>({
    roleId: String(),
    targetId: String(),
}) {}

export class OrganizationPerson extends Record<{
    organizationPersonId: string;
    organizationId: string;
    name: typeof Name.default;
    loginId: string;
    email: string | null;
    assignments: List<Assignment> | null;
    createdAt: string | null;
    behaviors: BehaviorsCollection;
}>({
    organizationPersonId: '',
    organizationId: '',
    name: Name.default,
    loginId: '',
    email: null,
    assignments: null,
    createdAt: null,
    behaviors: new BehaviorsCollection([]),
}) {}

export interface APIOrganizationPerson {
    email: string | null;
    name: string;
}

function fromAPI(data) {
    return new OrganizationPerson({
        organizationPersonId: data.organizationPersonId,
        organizationId: data.organizationId,
        loginId: data.loginId,
        email: data.email,
        name: Name.fromAPI(data.name),
        assignments: List(
            data.assignments.map(
                assignment =>
                    new Assignment({
                        roleId: assignment.roleId,
                        targetId: assignment.targetId,
                    }),
            ),
        ),
        createdAt: data.createdAt,
        behaviors: new BehaviorsCollection(data.behaviors),
    });
}

function toAPI(person: OrganizationPerson): APIOrganizationPerson {
    return {
        name: person.name.fullName,
        email: person.email,
    };
}

function fromFormData(formData: any) {
    const {name, email, organizationId} = formData;

    return new OrganizationPerson({
        name: new Name.record(Name.nameFromString(name)),
        email,
        organizationId,
    });
}

function toFormData(person: OrganizationPerson) {
    return {
        name: person.name.fullName,
        email: person.email,
    };
}

export default {
    record: OrganizationPerson,
    default: new OrganizationPerson(),
    fromAPI,
    toAPI,
    fromFormData,
    toFormData,
};
